import React, { memo } from 'react';
import _ from 'lodash';
import ReactEcharts, { EChartsOption } from 'echarts-for-react';
import { DEFAULT_OPTIONS } from 'routes/HumanResourcesModule/components/HrChart/eChartHelpers';
import NoData from 'routes/HumanResourcesModule/components/HrDataGrid/NoData';
import { Skeleton } from '@mui/material';
import Flex from 'ui/Flex/Flex';

type Props = {
    isLoading: boolean;
    options: EChartsOption;
};

const HrGaugeChart = ({ isLoading, options }: Props): React.ReactElement => {
    const echartOptions = {
        ...DEFAULT_OPTIONS,
        ...options,
    };
    const gaugeStatusClassName = isLoading ? 'gauge-max-value-loading' : '';

    return (
        <Flex
            justifyContent="center"
            flexDirection="column"
            sx={{ height: '100%', width: '100%' }}
        >
            {isLoading ? (
                <Skeleton
                    variant="rectangular"
                    width="80%"
                    height="80%"
                    sx={{ display: 'flex', alignSelf: 'center' }}
                />
            ) : (
                <>
                    {options === 0 ? (
                        <NoData />
                    ) : (
                        <ReactEcharts
                            option={echartOptions}
                            notMerge
                            className={`react_for_echarts ${gaugeStatusClassName}`}
                        />
                    )}
                </>
            )}
        </Flex>
    );
};

export default memo(HrGaugeChart, _.isEqual);
